import { createContext, useState } from "react";

interface DefaultDataType {
  dbaAgencySignup: {
    dbaId: number
    name: string
    users: {
      email: string
      role: string
      first_name: string,
      last_name: string,
      phone_number?: string,
      country_code?: string,
    }[]
  } | null
  accessToken: string | null
  setDbaAgencySignup: React.Dispatch<React.SetStateAction<DefaultDataType['dbaAgencySignup']>>
  setAccessToken: React.Dispatch<React.SetStateAction<DefaultDataType['accessToken']>>
}

const defaultData: DefaultDataType = {
  dbaAgencySignup: null,
  setDbaAgencySignup: () => {},
  accessToken: null,
  setAccessToken: () => {}
}

const DBAContext = createContext(defaultData)

const DBAProvider = ({ children }: any) => {
  const [ dbaAgencySignup, setDbaAgencySignup ] = useState(defaultData.dbaAgencySignup)
  const [ accessToken, setAccessToken ] = useState(defaultData.accessToken)

  return <DBAContext.Provider value={{
    dbaAgencySignup,
    setDbaAgencySignup,
    accessToken,
    setAccessToken
  }}>
    {children}
  </DBAContext.Provider>
}

export { DBAContext, DBAProvider }